import Accordion from "react-bootstrap/Accordion";
import "./accordion.css";
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { useProductList } from "constants/products";

function AccordionExpandibles({ setAccordionState }) {
  const navigate = useNavigate();
  const productList = useProductList();

  const handleNavigation = (path) => {
    if (path.startsWith("http")) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
  };

  return (
    <Accordion
      id="product-accordion"
      defaultActiveKey={0}
      onSelect={setAccordionState}
      data-aos="fade-down"
    >
      {productList.map((product, index) => (
        <Accordion.Item key={index} eventKey={index}>
          <Accordion.Header>
            <div className="d-inline-flex align-items-center">
              <img
                src={product.icon}
                width="30"
                className="me-3"
                alt={product.icon}
              />
              <div className="pt-2">{product.title}</div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            {product.content.map((item, itemIndex) => (
              <Badge
                key={itemIndex}
                pill
                bg="light"
                onClick={() => handleNavigation(item.path)}
              >
                {parse(item.title)}
              </Badge>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export default AccordionExpandibles;
